<template>
  <div id="app">
    <Header v-if="excludeRouteserror.indexOf($route.name) == -1"></Header>
    <router-view v-if="isRouterAlive"  />
    <!-- 部分路由不应该包含这个Footer -->
    <Footer v-if="excludeRoutes.indexOf($route.name) == -1"></Footer>
  </div>
</template>

<script>
import Header from '@/components/header/Header';
import Footer from '@/components/footer/Footer';
export default {
  name: 'App',
  provide () {    //父组件中通过provide来提供变量，在子组件中通过inject来注入变量。
    return {
      reload: this.reload,
      messages: [],
      topics:[
       'tab',
      ],
      content: ""
    }
  },
  data () {
    return {
      excludeRoutes: ['HomeIndex', 'MyAddress', 'AddAddress', 'MyOrder', 'MyShoppingCart',"404","machine","machineDetail", 'auction1','auction2','auction3','auction4','auction5','lottery','lotterys',"jhResidence","jhResidenceDetail", 'live'],
      excludeRouteserror: [ 'development','HomePage', 'about', 'project',"404","machine","machineDetail","jhResidence","jhResidenceDetail", 'auction1','auction2','auction3','auction4','auction5','lotterys', 'lottery', 'live'],
      isRouterAlive: true
    };
  },
  created(){
//初始化方法
    this.localSocket()


  },
  methods:{
    reload () {
      this.isRouterAlive = false;            //先关闭，
      this.$nextTick(function () {
        this.isRouterAlive = true;         //再打开
      })
    },

    localSocket() {
      let that = this;
      if ("WebSocket" in window) {
        // console.log("您的浏览器支持 WebSocket!");
        that.ws = new WebSocket('wss://screen-websocket.guolaiwan.net/server/websocket/web/' + '65b1f4a41e97420b96868b48a41d5ae7');
        that.global.setWs(that.ws);
        that.ws.onopen = function () {
        that.global.ws.send('topics:'+JSON.stringify(that.topics))
          console.log('websocket连接成功');
        };

        that.ws.onclose = function () {
          // 关闭 websocket
          console.log("连接已关闭...");
          //断线重新连接
          setTimeout(() => {
            that.localSocket();
          }, 2000);
        };
      } else {
        // 浏览器不支持 WebSocket
        console.log("您的浏览器不支持 WebSocket!");
        alert('error', '浏览器', '您的浏览器不支持显示消息请更换', 1,1)
      }
    },

  },
  components: {
    Header,
    Footer
  }
};
</script>
<style>
 .mouse-cover-canvas{
   left: 800px !important;
   top: 80px !important;
 }
</style>



// WEBPACK FOOTER //
// src/App.vue